<template>
  <div class="row m-0 h-100 bg align-items-center">
    <div class="col-12">
      <div class="row m-0 justify-content-center">
        <div class="col-12">
          <center>
            <h1>CONGRATULATIONS!</h1>
          </center>
        </div>
        <div class="col-1 mt-4 mb-4 pt-1 pl-0 pr-0">
          <div class="border_white"></div>
        </div>
        <div class="col-12 mt-2">
          <center>
            <h3>YOU HAVE COMPLETED THE CHALLENGE IN</h3>
          </center>
        </div>
        <div class="col-12 mt-4 mb-4">
          <center>
            <h1>{{ timeTaken / 1000 }}</h1>
          </center>
        </div>
        <div class="col-12 p-0 pr-1">
          <center>
            <h3>SECONDS</h3>
          </center>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Congrats',
  computed: {
    ...mapGetters([
      'timeStart',
      'timeEnd'
    ]),
    timeTaken () {
      return this.timeEnd - this.timeStart < 90000 ? this.timeEnd - this.timeStart : 90000
    }
  },
  created () {
    let vm = this
    var timeleft = 10
    var downloadTimer = setInterval(function () {
      --timeleft
      if (timeleft <= 0) {
        clearInterval(downloadTimer)
        vm.$router.push('/leaderboard')
      }
    }, 1000)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg {
/*   background-image: url('../assets/images/side_bg.png'); */
  background: -webkit-linear-gradient(45deg, rgb(0, 75, 141) 0%, rgb(185, 140, 96) 100%);
  background-size: cover;
}
.border_white {
  background: #fff;
  padding: 1px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Congrats.vue